import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { getStaanderPositionName } from "entities/configurator/model/layoutChoiceName";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import { useSlides } from "./helpers/useSlideHelper";

type MobileConfiguratorOptionHeaderProps = {
  activeIndex: number;
};
export const MobileConfiguratorOptionHeader = ({
  activeIndex,
}: MobileConfiguratorOptionHeaderProps) => {
  const {
    handle,
    color,
    layout,
    glass,
    staanderPosition,
    staanderOption,
    getConfiguredOptionPrices,
  } = useConfigurationOptionsContext();
  const { slides } = useSlides();
  const optionsMap = [layout, color, glass, handle];
  const configuredOptionPrices = getConfiguredOptionPrices();
  const optionPriceMap = [
    configuredOptionPrices.layout,
    configuredOptionPrices.color,
    configuredOptionPrices.glass,
    configuredOptionPrices.handle,
  ];
  // Header main text
  const headerMainText = slides[activeIndex].headerMainText ?? "";

  // Current option
  let currentOption = optionsMap[activeIndex]?.name ?? "Geen keuze";
  if (activeIndex === 0 && layout && staanderPosition) {
    currentOption = `${layout.name} + ${getStaanderPositionName(staanderPosition)}`;
  }

  // Current price
  const currentOptionPrice =
    (optionPriceMap[activeIndex] ?? 0) +
    (activeIndex === 0 && staanderPosition ? (staanderOption?.price ?? 0) : 0);
  // Current price formatted
  const currentOptionPriceFormatted =
    "+" + getFormattedPrice(currentOptionPrice);

  return (
    <div className="gg-sticky gg-top-0 gg-z-10 gg-bg-white gg-px-6 gg-py-2.5 gg-shadow-sm">
      <h2 className="gg-text-base gg-font-semibold gg-text-dark-blue">
        {headerMainText}
      </h2>

      <div
        className={`gg-mt-1.5 gg-flex gg-justify-between ${activeIndex === 4 ? "gg-invisible" : ""}`}
      >
        {/* Choice */}
        <div>
          <h5 className="gg-text-xs gg-font-semibold gg-text-dark-blue/80">
            Huidige keuze:
          </h5>
          <p className="gg-h-4 gg-text-xs gg-text-dark-blue">{currentOption}</p>
        </div>

        {/* Price */}
        <p className="gg-text-xs gg-font-bold gg-text-dark-blue">
          {currentOptionPriceFormatted}
        </p>
      </div>
    </div>
  );
};
